import { IUserTempDataKeys, IUserTempDataMap } from '../../interfaces/Element.interfaces';
import { getUserTempData } from '../getter/getUserTempData.util';
import { setUserTempDataToMap } from '../setter/setUserTempData.util';

export interface IRemoveUserTempDataFromMapParam {
  userId?: string;
  dataKey: IUserTempDataKeys;
}

interface IRemoveUserTempDataFromMapReturn {
  newTempDataMap: IUserTempDataMap;
}

export const removeUserTempDataFromMap = ({
  userId,
  dataKey,
}: IRemoveUserTempDataFromMapParam): IRemoveUserTempDataFromMapReturn => {
  const { userTempData } = getUserTempData(userId);
  userTempData.delete(dataKey);

  const { newTempDataMap } = setUserTempDataToMap({ userId, newTempData: userTempData });
  return { newTempDataMap };
};
